'use strict';

import { IScope } from "angular";
import { AAO, AAOEntryResponseElement, AAOVehicleAssignment } from "../../../../data/aao.data";
import {RolePrivilege} from "../../../../data/privileges.enum";
import {Vehicle, VehiclesSimplePaginatedResponse} from "../../../../data/vehicles.data";
import PrivilegeService from "../../../../services/privilege.service";
import RestService from "../../../../services/rest.service";
import { SortParams } from "../../../views/addressbook.view.component/addressbook.view.component";

require('./aao.vehicles.css');

/* @ngInject */
export default class AAOVehiclesModalController {
  public $scope: IScope;
  public $uibModal;
  public $uibModalInstance: any;
  public restService: RestService;
  public isLoading: boolean = false;

  public vehicles: VehiclesSimplePaginatedResponse;
  public vehicleParams = {
    searchFilter: '',
    currentPage: 0,
    totalElements: 0,
    pageSize: 10
  } as SortParams;

  public entry: AAOEntryResponseElement;
  public aao: AAO;
  public okFunction;

  public orders: AAOVehicleAssignment[] = [];


  constructor($scope: IScope, $uibModalInstance, $uibModal, restService: RestService, aao: AAO, entry: AAOEntryResponseElement, okFunction,
    public privilegeService: PrivilegeService) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$uibModal = $uibModal;
    this.restService = restService;
    this.entry = entry;
    this.aao = aao;
    this.okFunction = okFunction;
    this.load();
  }

  load() {
    this.isLoading = true;
    this.restService.getAAOAssignments(this.aao, this.entry).then(assignments => {
      this.orders = assignments;
    }).finally(() => {
      this.isLoading = false;
      this.$scope.$applyAsync();
    });
  }

  addVehicleToAAO(vehicle: Vehicle) {
    const index = this.orders.filter(entry => entry.vehicle.id === vehicle.id).length;
    if (index > 0) return; // Vehicle is already part of AAO

    this.orders.push({
      order: 5,
      vehicle: vehicle
    });
    this.sort(this.orders);
  }

  setVehicleOrder(vehicle: AAOVehicleAssignment, newOrder: number) {
    vehicle.order = newOrder;
    this.sort(this.orders);
  }

  removeVehicleOrder(vehicle: AAOVehicleAssignment) {
    const index = this.orders.indexOf(vehicle);
    if (index > -1) {
      this.orders.splice(index, 1);
    }
  }

  sort(orders: AAOVehicleAssignment[]): AAOVehicleAssignment[] {
    orders.sort((a, b) => {
      if (a.order === b.order) return a.vehicle.name.localeCompare(b.vehicle.name);
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
    });
    return orders;
  }

  searchForVehicle() {
    this.isLoading = true;

    this.restService.loadVehiclesPaginatedSimple(this.vehicleParams.currentPage === 0 ? 0 : this.vehicleParams.currentPage - 1,
      this.vehicleParams.pageSize,
      this.vehicleParams.searchFilter,
      'ASC').then(vehicles => {
        this.vehicles = vehicles;
      }).finally(() => {
        this.isLoading = false;
        this.$scope.$applyAsync();
      });
  }

  openVehicle(vehicle: Vehicle) {
    if (!this.privilegeService.has(RolePrivilege.Station_Vehicles_ReadDetails)) {
      return;
    }
    this.$uibModal.open({
      template: require('../vehicle.modal/vehicle.modal.html'),
      controller: 'VehicleModalController',
      controllerAs: 'ctrl',
      backdrop: 'static',
      size: 'lg',
      resolve: {
        vehicle: () => {
          return vehicle;
        },
        vehicleId: () => {
          return undefined;
        },
        okFunction: () => {
          return;
        }
      }
    });
  }

  save() {
    this.isLoading = true;
    this.restService.saveAAOAssignments(this.aao, this.entry, this.orders).finally(() => {
      // Create new tooltip
      const vehicleHtmlPreview = this.orders.map(order => `<b>${order.order}.</b> ${order.vehicle.name}`).join('<br>');
      this.okFunction(vehicleHtmlPreview);
      this.$uibModalInstance.close();
    });
  }

  cancel() {
    this.$uibModalInstance.close();
  }

  isSelected(vehicle: Vehicle): boolean {
    return this.orders.filter(e => e.vehicle.id === vehicle.id).length > 0;
  }
}
